// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZkoJnhamZpkRTgRe{border:1px solid var(--py-neutral-4);border-radius:4px;padding:8px;font-weight:inherit;color:inherit}.ZkoJnhamZpkRTgRe::placeholder{color:var(--py-neutral-4)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textareaInput": `ZkoJnhamZpkRTgRe`
};
export default ___CSS_LOADER_EXPORT___;
